import { call, put, takeEvery, select } from "redux-saga/effects";
import { AxiosDefaults } from "axios";
import * as actions from "actions";
import * as api from "api";
import * as Types from "Types";

function* getTemp(action: any) {
   const { temp_exhibition_idx = 0 } = action.payload;

   const queryObject: any = {
      temp_exhibition_idx,
   };
   const queryString = Object.entries(queryObject)
      .map((e) => e.join("="))
      .join("&");

   const status: string = yield select(function (state: any) {
      return state.temp.get.status;
   });
   if (status === api.statuses.pending) return;
   try {
      yield put({
         type: actions.temp.get.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: AxiosDefaults<any> = yield call(api.instance.get, `${api.temp.get.uri}?${queryString}`);
      // eslint-disable-next-line eqeqeq
      if ((response as any).code == 200) {
         yield put({
            type: actions.temp.get.success,
            payload: response,
         });
      } else {
         yield put({
            type: actions.temp.get.fail,
            payload: response,
         });
      }
   } catch (error) {
      yield put({
         type: actions.temp.get.fail,
         payload: error,
      });
   }
}

function* setTemp(action: any) {
   const {
      temp_exhibition_idx,
      v_name,
      email,
      hp,
      name,
      museum,
      startdate,
      enddate,
      runtime,
      author,
      authorplus,
      file2,
      files,
      exhibition_id,
      bank_name,
      acount_holder,
      exh_homepage,
      should_cash_receipt,
      order_code,
      is_ordered,
      is_inserted,
      is_sent,
   } = action.payload;

   const parameters = {
      temp_exhibition_idx,
      v_name,
      email,
      hp,
      name,
      museum,
      startdate,
      enddate,
      runtime,
      author,
      authorplus,
      file2,
      files,
      exhibition_id,
      exh_homepage,
      bank_name,
      acount_holder,
      should_cash_receipt,
      order_code,
      is_ordered,
      is_inserted,
      is_sent,
   };

   const status: string = yield select(function (state: Types.SagaStates) {
      return state.temp.set.status;
   });
   if (status === api.statuses.pending) return;
   try {
      yield put({
         type: actions.temp.set.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: AxiosDefaults<any> = yield call(api.instance.post, `${api.temp.set.uri}`, parameters);
      // eslint-disable-next-line eqeqeq
      if ((response as any).code == 200) {
         yield put({
            type: actions.temp.set.success,
            payload: response,
         });
      } else {
         yield put({
            type: actions.temp.set.fail,
            payload: response,
         });
      }
   } catch (error) {
      yield put({
         type: actions.temp.set.fail,
         payload: error,
      });
   }
}

function* syncTemp(action: any) {
   const {
      temp_exhibition_idx,
      v_name,
      email,
      hp,
      name,
      museum,
      startdate,
      enddate,
      runtime,
      author,
      authorplus,
      file2,
      files,
      exhibition_id,
      exh_homepage,
      bank_name,
      acount_holder,
      should_cash_receipt,
      order_code,
      is_ordered,
      is_inserted,
      is_sent,
   } = action.payload;

   const parameters = {
      temp_exhibition_idx,
      v_name,
      email,
      hp,
      name,
      museum,
      startdate,
      enddate,
      runtime,
      author,
      authorplus,
      file2,
      files,
      exhibition_id,
      exh_homepage,
      bank_name,
      acount_holder,
      should_cash_receipt,
      order_code,
      is_ordered,
      is_inserted,
      is_sent,
   };

   const status: string = yield select(function (state: Types.SagaStates) {
      return state.temp.sync.status;
   });
   if (status === api.statuses.pending) return;
   try {
      yield put({
         type: actions.temp.sync.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: AxiosDefaults<any> = yield call(api.instance.post, `${api.temp.sync.uri}`, parameters);

      console.log("response", response);
      // eslint-disable-next-line eqeqeq
      if ((response as any).code == 200) {
         yield put({
            type: actions.temp.sync.success,
            payload: response,
         });
      } else {
         yield put({
            type: actions.temp.sync.fail,
            payload: response,
         });
      }
   } catch (error) {
      yield put({
         type: actions.temp.sync.fail,
         payload: error,
      });
   }
}

function* orderClone(action: any) {
   const { order_code, temp_exhibition_idx } = action.payload;

   const parameters = {
      order_code,
      temp_exhibition_idx,
   };


   const status: string = yield select(function (state: Types.SagaStates) {
      return state.temp.orderClone.status;
   });


   if (status === api.statuses.pending) return;
   try {

      yield put({
         type: actions.temp.orderClone.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: AxiosDefaults<any> = yield call(api.instance.post, `${api.temp.orderClone.uri}`, parameters);

      // eslint-disable-next-line eqeqeq
      if ( (response as any).code == 200) {
         yield put({
            type: actions.temp.orderClone.success,
            payload: response,
         });
      } else {
         yield put({
            type: actions.temp.orderClone.fail,
            payload: response,
         });
      }

   } catch (error) {

      yield put({
         type: actions.temp.orderClone.fail,
         payload: error,
      });

   }
}

export function* tempSaga() {
   yield takeEvery(actions.temp.get.call, getTemp);
   yield takeEvery(actions.temp.set.call, setTemp);
   yield takeEvery(actions.temp.sync.call, syncTemp);
   yield takeEvery(actions.temp.orderClone.call, orderClone);
}
